var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert.show)?_c('v-alert',{staticClass:"alert-custom",attrs:{"type":_vm.alert.type,"dismissible":""},on:{"input":_vm.clear}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }